import React from 'react';
import CrownIcon from "../../assets/images/icons-crown.svg";

const LiveTestHeader = props => {
    const { testData, toggleQuizSave } = props;
    return (
        <div className="tags">
            <div className="label-field">
                <i className={'fa ' + (!testData.isSaved ? 'fa-bookmark-o' : 'fa-bookmark')}
                   style={{ cursor: 'pointer' }} onClick={toggleQuizSave}/>
                {
                    testData.pricing === "PAID" && <img src={CrownIcon} alt="crown icon" className="crownIcon"/>
                }
                <span className={testData.mode.split('-')[0]}>
                                    {testData.mode.toUpperCase()}</span>
            </div>

        </div>
    );
};

export default LiveTestHeader;
